import { useFeatureEntitlements } from "@frontegg/react";
import useCardPrograms from "hooks/useCardPrograms";

/**
 * Whether out-of-pocket reimbursements are available to this tenant, or
 * undefined until its card programs are known.
 *
 * Both halves are load-bearing: the entitlement is sold separately, and payouts
 * run from the default program, so a tenant with no program cannot pay one out.
 */
export const useShowReimbursements = (): boolean | undefined => {
  const { isEntitled: featureOutOfPocket } = useFeatureEntitlements(
    "feature_out_of_pocket",
  );
  const { defaultProgram, loaded } = useCardPrograms(!featureOutOfPocket);

  if (!featureOutOfPocket) return false;
  return loaded ? Boolean(defaultProgram) : undefined;
};

export default useShowReimbursements;
